import { useState } from 'react'
import { Layout, Empty, Button, Splitter } from 'antd'
import { RightOutlined, LeftOutlined } from '@ant-design/icons'
import MessagesHeader from './Conversations/Online/MessagesHeader'
import MessagesWrapper from './Conversations/Online/MessagesWrapper'
import ConversationsList from './Conversations/Online/ConversationsList'
import OrderProfile from '@/components/OrderProfile'
import useAuthStore from '@/stores/AuthStore'
import ReplyWrapper from './Conversations/Online/ReplyWrapper'
import useConversationStore from '@/stores/ConversationStore'
import { useShallow } from 'zustand/react/shallow'

import ConversationBind from '@/views/Conversations/Online/ConversationBind'
import './Conversations/Conversations.css'
import EmailEditorPopup from './Conversations/Online/Input/EmailEditorPopup'

const { Sider, Content, Header, Footer } = Layout

const ChatWindow = () => {
  const [collapsedRight, setCollapsedRight] = useState(false)
  const [rightSize, setRightSize] = useState(400)

  const loginUser = useAuthStore((state) => state.loginUser)
  const currentOrder = useConversationStore(useShallow((state) => state.currentConversation?.coli_sn || ''))
  const currentConversationID = useConversationStore(useShallow((state) => state.currentConversation?.sn || ''))
  const [updateCurrentConversation] = useConversationStore((state) => [state.updateCurrentConversation])

  const renderEmptyOrder = () => {
    return (
      <Empty description={<span>没有订单关联</span>}>
        <ConversationBind currentConversationID={currentConversationID} userId={loginUser.userId} onBoundSuccess={(coli_sn) => updateCurrentConversation({ coli_sn })} />
      </Empty>
    )
  }

  return (
    <>
      <Layout hasSider className='h-screen chatwindow-wrapper' style={{ maxHeight: 'calc(100% - 166px)', height: 'calc(100% - 166px)' }}>
        <Sider
          width={380}
          theme={'light'}
          className='h-full overflow-y-auto h-parent'
          style={{ maxHeight: 'calc(100vh - 166px)', height: 'calc(100vh - 166px)' }}
          collapsible={true}
          breakpoint='xl'
          collapsedWidth={73}
          collapsed={false}
          onBreakpoint={(broken) => {
            // setCollapsedLeft(broken)
            // setCollapsedRight(broken)
          }}
          trigger={null}>
          <ConversationsList />
        </Sider>

        <Content style={{ maxHeight: 'calc(100vh - 166px)', height: 'calc(100vh - 166px)', minWidth: '360px' }}>
          <Splitter
            onResize={(sizes) => {
              if (sizes[1] > 0) setRightSize(sizes[1])
            }}>
            <Splitter.Panel min={360}>
          <Layout className='h-full'>
            <Header className='px-1 ant-layout-sider-light bg-white ant-card h-auto flex justify-between gap-1 items-center'>
              {/* <Button type='text' icon={collapsedLeft ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />} onClick={() => setCollapsedLeft(!collapsedLeft)} className=' rounded-none rounded-l' /> */}
              <MessagesHeader />
              {/* <Button type='text' icon={<ReloadOutlined />} onClick={() => setCollapsedRight(!collapsedRight)} className='' title='最新消息记录' /> */}
              <Button type='text' icon={collapsedRight ? <RightOutlined /> : <LeftOutlined />} onClick={() => setCollapsedRight(!collapsedRight)} className=' rounded-none rounded-r' />
            </Header>
            <Content className='flex-grow bg-whatsapp-bg relative'>
              <MessagesWrapper />
            </Content>
            <Footer className='ant-layout-sider-light p-0'>
              <ReplyWrapper />
              {/* <hr />
              <InputComposer /> */}
            </Footer>
          </Layout>
            </Splitter.Panel>
            <Splitter.Panel size={collapsedRight ? 0 : rightSize} min={collapsedRight ? 0 : 320} max={520}>
              <OrderProfile coliSN={currentOrder} renderEmpty={renderEmptyOrder} />
            </Splitter.Panel>
          </Splitter>
        </Content>
      </Layout>
      <EmailEditorPopup key='email-editor-online' />
    </>
  )
}

export default ChatWindow
